// @givmo/app-admin — admins list presentation helpers (07-1.5b).
//
// The tolerant list extraction for the admins list endpoint
// (`GET /admin/company/admins`) is the shared `extractList` from
// `@givmo/api-client/list` — the admins page calls it directly with `AdminOut`.
// This module keeps the admins-specific display helper.

import type { AdminOut } from '@givmo/api-client';

/**
 * Full display name from `first_name` + `last_name`, guarding nulls so a missing surname never renders
 * "First null" (the Flutter `getFullName()` interpolates both unguarded — improved here). Falls back to
 * the email when both name parts are blank.
 */
export function adminFullName(admin: AdminOut): string {
  const name = [admin.first_name, admin.last_name].filter(Boolean).join(' ').trim();
  if (name.length > 0) return name;
  return admin.email || '';
}
